import { mapState } from "vuex";
 
export default {
    computed: {
      ...mapState("token", ["token"]),
    },
    data() {
      return {
        time: null,
        // Intervalo (en ms) para volver a refrescar el token
        interval: 600000,
        //interval: 15000,
      };
    },
    methods: {
      refreshToken() {
        this.$store.dispatch("token/refreshToken").then(() => {
          // this.$store.dispatch("user/loadUser", this.token);
        });
      },
    },
    beforeMount() {
      this.time = window.setInterval(() => {
        this.refreshToken();
      }, this.interval);
    },
}